import store from '../store'
import { baseApi, adminApi, patentApi } from './api'

export function storeUserInfo () {
  return store.state.userInfo
}
export function storeCompanyInfo () {
  return JSON.parse(sessionStorage.getItem('companyInfo'))
}

// 保存租户信息
export const saveSaasCompanyInfo = (data) => {
  return baseApi({
    url: '/zgTenant/updateZgTenant',
    method: 'put',
    data
  })
}
// 获取当前租户业务必填项开关
export const getZgTenantRequiredSwitch = () => {
  return patentApi({
    url: '/zcyPtTenantConfig/getZgTenantRequiredSwitch',
    method: 'get'
  })
}
// 根据oss半路经获取全路径
export const getOssFullPath = (data) => {
  return adminApi({
    url: '/newFile/getUrl',
    method: 'post',
    data
  })
}

// oss文件下载
export const downFileStream = data => {
  return adminApi({
    url: '/newFile/downFileStream',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
export const hiddenCheckbox = () => {
  const displayCheckboxList = document.getElementsByName('disabled')
  displayCheckboxList.forEach(item => {
    item.parentNode.parentNode.parentNode.className = item.className + ' hidden'
  })
}
// 获取唯一值
export const getUid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export const utils = {
  // getTrademarkPath (flowType = '', pcode = '', typeCode = '') {
  //   const bzxPcodeMap = [
  //     'tr_extent',
  //     'tr_change',
  //     'tr_change_agent',
  //     'tr_off',
  //     'tr_append',
  //     'tr_modify',
  //     'tr_permit',
  //     'tr_concel',
  //     'tr_transfer',
  //     'tr_tf'
  //   ]
  //   if (flowType === 'tr_bohui') {
  //     return 'bh'
  //   } else if (bzxPcodeMap.includes(typeCode)) {
  //     return 'bzx'
  //   } else if (pcode.indexOf('tr_reg_') !== -1) {
  //     return 'tr'
  //   } else {
  //     return 'tr'
  //   }
  // }
  getTrademarkPath (flowTableCode = '') {
    const bzxPcodeMap = [
      'tr_extent',
      'tr_change',
      'tr_change_agent',
      'tr_off',
      'tr_append',
      'tr_modify',
      'tr_permit',
      'tr_concel',
      'tr_transfer'
      // 'tr_tf' //去掉这个 周华说的 20210922
    ]
    if (flowTableCode === 'tr_bohui') {
      return 'bh'
    } else if (bzxPcodeMap.includes(flowTableCode)) {
      return 'bzx'
    } else if (flowTableCode === 'tr_reg') { // 增加 tr_ 和 pt 判断 20210630
      return 'tr'
    } else {
      return 'tr'
    }
  },
  getUid
}

export const getUrl = (() => {
  const objUrl = {}
  if (window.location.href.indexOf('?') > 0) {
    const url = window.location.href.split('?')[1]
    // a=123 b=456
    const urlArr = url.match(/[^?&]+=[^?&]+/g)
    if (urlArr && urlArr.length > 0) {
      urlArr.forEach(item => {
        const curr = item.split('=')
        const key = curr[0]
        const value = curr[1]
        objUrl[key] = value
      })
    }
  }

  return objUrl
})()
